module.exports = __webpack_public_path__ + "static/media/404.7c160b2f.svg";